// Canonical list of everyone who can be tagged as "watched/played with" somewhere on the site.
// Keep this in one place so every "Filter by person" dropdown offers the same set of people.
export const PEOPLE = [
  { value: 'Joy', label: 'Joy <3' },
  { value: 'Rick', label: 'Rick' },
  { value: 'Lisa', label: 'Lisa' },
  { value: 'Gionnan', label: 'Gionnan' },
  { value: 'Youssra', label: 'Youssra' },
];

// Narrows PEOPLE down to only the people who actually have at least one tagged item in `items`.
// `fieldForPerson` maps a person's value to the boolean column to check (e.g. 'watched_with_joy'),
// and can return undefined/null for a person that doesn't apply to this content type at all (e.g.
// there's no "played_with_joy" column on games) — those are dropped too. This keeps a dropdown from
// ever offering an option that's guaranteed to return an empty list.
export function availablePeople(items, fieldForPerson) {
  return PEOPLE.filter((person) => {
    const field = fieldForPerson(person.value);
    return field && items.some((item) => item[field] === true);
  });
}
